export default import.meta.ROLLDOWN_FILE_URL_Zzi1Uvtbp2$IAZepOrT$9A